import './quietConsole';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import { Auth0Provider } from '@auth0/auth0-react';
import AppWrapper from './App';
import { WiloutProvider } from './context/WiloutContext';
import { RolesProvider } from './context/RolesContext';
import PublicAccreditationApp from './features/accreditation-external/PublicAccreditationApp';

const auth0Domain = window.env?.auth0Domain;
const auth0ClientId = window.env?.auth0ClientId;
const auth0Audience = window.env?.auth0Audience;

// Config formulaire d'accréditation externe / formulaire public / suivi de statut / export des
// séances d'un client / saisie d'IBAN d'un participant à rembourser
// séances d'un client : ces chemins ne doivent JAMAIS déclencher le login Auth0 des employés
// Wilout (visiteurs externes, sans compte).
// Testé ici, avant tout provider authentifié, pour qu'aucun de leurs effets de bord au montage
// ne se déclenche pour un visiteur public.
const isPublicAccreditationPath = /^\/(accreditation-(config|form|status)|export-seances|remboursement)(\/|$)/.test(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isPublicAccreditationPath ? (
      <PublicAccreditationApp />
    ) : (
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: auth0Audience,
        }}
        cacheLocation="localstorage"
      >
        <WiloutProvider>
          <RolesProvider>
            <AppWrapper />
          </RolesProvider>
        </WiloutProvider>
      </Auth0Provider>
    )}
  </React.StrictMode>
);
